import { DEVICES, DEVICE_IMG, MedconnectDevicesConfig } from '@/constants/medconnect-devices-types'
import { getConfig, restartDevice } from '@/core/classes/MedconnectDevicesAPI'
import { useCallback, useEffect, useMemo, useState } from 'react'
import SelectDeviceComponent, { DeviceData } from '../components/SelectDevice'
import { getCustomDevices, selectCustomDevices } from '@/redux/reducers/custom-device.reducer'
import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import StartLocalConsultationDialog from './StartLocalConsultationDialog'
import { useTranslation } from 'react-i18next'

export enum DeviceType {
  'medicalVideo' = 'medicalVideo',
  'stethoscope' = 'stethoscope',
  'mesures' = 'mesures',
  'biologicals' = 'biologicals',
}

type SelectDeviceProps = {}

export default function SelectDeviceCard(props: SelectDeviceProps) {
  const [createLocalConsultation, setCreateLocalConsultation] = useState(false)
  const [deviceType, setDeviceType] = useState<DeviceType | undefined>(undefined)
  const { t } = useTranslation()

  const onDeviceSelected = useCallback(
    (type: DeviceType) => {
      console.log('onDeviceSelected', type)
      setDeviceType(type)
      setCreateLocalConsultation(true)

    },
    [setDeviceType]
  )
  const [config, setConfig] = useState<MedconnectDevicesConfig | undefined>(undefined)
  const dispatch = useAppDispatch()

  const customDevices = useAppSelector(selectCustomDevices)

  useEffect(() => {
    dispatch(getCustomDevices())
  }, [dispatch])

  useEffect(() => {
    const handleConfig = async () => {
      const config = await getConfig()
      if (!config) return
      setConfig(config)
    }
    handleConfig()
  }, [])

  const devices: DeviceData[] = useMemo(() => {
    const handleDeviceSelected = (type: DeviceType) => {
      onDeviceSelected(type)
    }
    const devices: DeviceData[] = []
    // get custom devices
    if (customDevices.length > 0) {
      customDevices.forEach((device) => {
        devices.push({
          name: device.customName,
          id: device._id,
          src: device.iconURL,
          onClick: () => {
            handleDeviceSelected(device.type === 'stethoscope' ? DeviceType.stethoscope : DeviceType.medicalVideo)
          },
        })
      })
    }
    if (!config?.Devices) return devices
    // get devices from config
    if (config && config.Devices.length > 0) {
      config.Devices.forEach((device) => {
        if (device.name === DEVICES.ECG_WATCH_FOLDER) return
        devices.push({
          name: t(`component.ui.deviceCard.deviceLabels.${device.name}`),
          id: device._id,
          src: DEVICE_IMG[device.name],
          onClick: async () => {
            await restartDevice(device._id)
            handleDeviceSelected(device.name === DEVICES.PM6100 ? DeviceType.biologicals : DeviceType.mesures)
          },
        })
      })
    }

    return devices
  }, [config, customDevices, onDeviceSelected, t])

  return (
    <>
      <SelectDeviceComponent devices={devices} />
      {deviceType && <StartLocalConsultationDialog open={createLocalConsultation} onClose={() => setCreateLocalConsultation(false)} type={deviceType} />}
    </>
  )
}
